import { rem } from "polished";
import styled from "styled-components";

import { withViewportStyle } from "@/components/editor/shared/with-viewport-style";

export const PositionedWrapper = styled.div`
  position: relative;

  .background-squiggle {
    position: absolute;
    top: min(65%, 320px);
    left: 34%;
    transform: rotate(60deg);
  }
`;

export const ContentWrapper = withViewportStyle("div")`
  position: relative;
  display: grid;
  align-items: center;
  grid-template-columns: 1fr 1fr;
  gap: ${rem(128)};

  ${(props) => props.$viewport.tablet`
    gap: ${rem(24)};
  `}

  ${(props) => props.$viewport.mobile`
    grid-template-columns: auto; 
  `}

  .image-primitive {
    border-radius: ${rem(20)};
    max-width: ${rem(496)};
    margin: auto;
  }
`;
